/* AppraisalComponents/hooks/useSheetProfileCascade.js
 * Phase C · C4c Sheet extraction (2026-02c).
 *
 * Owns the two Sheet-section useEffects that keep `sheetSectionProfile`
 * aligned with the rate catalogue's case AND stamp that profile onto
 * every Sheet row that arrives without one. Extracted from
 * AppraisalComponentsTab.js:298-319.
 *
 * State stays in the parent · this hook accepts state slices + setters.
 */
import { useEffect } from 'react';

export function useSheetProfileCascade({
  sheetSectionProfile,
  setSheetSectionProfile,
  sheetProfileNames,
  groupsSheetLength,     // groups.Sheet?.length — cheap dep
  setGroups,
}) {
  // Iter189 · case-normalise the operator's `sheetSectionProfile` to the
  // rate catalogue's canonical case (roof_details often has "Trimrib"
  // but the catalogue uses "TrimRib" · without this the picker shows
  // "Any profile" instead of preselecting).
  useEffect(() => {
    if (!sheetSectionProfile || !sheetProfileNames.length) return;
    if (sheetProfileNames.includes(sheetSectionProfile)) return;
    const match = sheetProfileNames.find(
      p => p.toLowerCase() === sheetSectionProfile.toLowerCase(),
    );
    if (match) setSheetSectionProfile(match);
  }, [sheetSectionProfile, sheetProfileNames, setSheetSectionProfile]);

  // Iter189 · stamp `sheetSectionProfile` onto every Sheet row that has
  // no profile set. Already-customised rows are left alone.
  useEffect(() => {
    if (!sheetSectionProfile) return;
    setGroups(prev => {
      const sheets = prev.Sheet || [];
      if (!sheets.length) return prev;
      const needsUpdate = sheets.some(l => !l.profile);
      if (!needsUpdate) return prev;
      return {
        ...prev,
        Sheet: sheets.map(l => l.profile ? l : { ...l, profile: sheetSectionProfile }),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sheetSectionProfile, groupsSheetLength]);
}
